<!--
  功能：汽车行业
  cyz
  邮箱：cyz@126.com
  时间：2023年02月17日 09:29:47
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="trade-type">
        <div class="trade-box" v-for="(item,index) in SourceData" :key="index">
            <div class="trade-content">
                  <div class="trade-info">
                    <div class="trade-items">
                        <h5>{{item.name}}</h5>
                        <span>{{item.date}}</span>
                    </div>
                    <div class="items-content">
                        <span>{{item.content}}</span>
                    </div>
                    <div class="items-href">
                      <a :href="item.path">
                        <div style="float:left">
                          阅读全文
                        </div>
                        <img :src="require(`../../assets/svg/nav.svg`)" class="news-more"/>
                      </a>
                  </div>
                  </div>
            </div>
            <div class="trade-img">
                <img :src="require(`../../assets/news/${item.imgurl}`)"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  // 组件名称
  name: 'Cartrade',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
        SourceData:[
        {
          name:'与福田戴姆勒携手，走完全价值链数字化转型之路1',
          date:'2022.08.12',
          content:'远程审计按需审计，由持续风险监控和评估输出结果触发。非现场数字化审计作业工具支撑数字化持续审计多层级交互，省公司及地市间的管理。审计项目底稿、疑点工单管理、疑点核实工单一键生成、疑点核实工单追踪反馈、审计底稿一键生成等基本功能，实现整个审计项目疑点的下发、核实、反馈的相关流程，达到审计成果应用最大化。',
          path:'#',
          imgurl:'qchy1.png'
        },
        {
          name:'与福田戴姆勒携手，走完全价值链数字化转型之路2',
          date:'2022.08.24',
          content:'远程审计按需审计，由持续风险监控和评估输出结果触发。非现场数字化审计作业工具支撑数字化持续审计多层级交互，省公司及地市间的管理。审计项目底稿、疑点工单管理、疑点核实工单一键生成、疑点核实工单追踪反馈、审计底稿一键生成等基本功能，实现整个审计项目疑点的下发、核实、反馈的相关流程，达到审计成果应用最大化。',
          path:'#',
          imgurl:'qchy1.png'
        }
      ]
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {},
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
  * 在实例初始化之后，组件属性计算之前，如data属性等
  */
  beforeCreate () {
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
  },
  mounted () {
  },
  
}
</script> 

<style lang="less" scoped>
    .trade-type{
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      .trade-box{
        width:100%;
        height:auto;
        display:flex;
        justify-content:flex-start;
        background-color:#fff;
        margin-bottom:20px;
        .trade-img {
          width:340px;
          height:100%;
          float: left;
          img{
            width: 100%;
            height:100%;
          }
        }
        .trade-content {
          width: calc(100% - 340px);
          height: 100%;
          float: left;
          .trade-info{
            width: 100%;
            height:100%;
            overflow-y:auto;
            .trade-items{
              width: calc(100% - 5rem);
              height: auto;
              display: flex;
              justify-content: flex-start;
              padding:20px 40px;
              float:left;
              h5{
                font-size: 1.125rem;
                font-weight:600;
                color:#1d6aac;
                margin:0;
                float:left;
              }
              span{
                padding-left: 10px;
                font-size: 12px;
                line-height: 27px;
                color: #888989;
                float: left;
              }
            }
            .items-content{
              width: calc(100% - 60px);
              height: auto;
              margin: 0px 30px 0 30px;
              float:left;
              display: flex;
              justify-content: center;
              span{
                font-size: 14px;
                line-height: 28px;
                color: #46484a;
                font-weight: 300;
                width: 100%;
                white-space: pre-line;
              }
            }
            .items-href{
              width: calc(100% - 60px);
              height: 20px;
              margin: 10px 30px 20px 30px;
              float:left;
              a{
                text-decoration: none;
                color: #519ad8;
                font-size: 14px;
                line-height: 28px;
                display:flex;
                justify-content:flex-start;
                img{
                  vertical-align: middle;
                  border-style: none;
                }
                .news-more {
                  float: right;
                  margin: 5px;
                }
              }
            }
          }
        }
      }
    }
  </style>
  